import {createSelector} from 'reselect';
import {userBranch} from './user';

export const isLoggedIn = createSelector(
    userBranch,
    user => user.loggedIn
);



// WEBPACK FOOTER //
// /src/redux/selectors/auth.js